import { createServerFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { z } from 'zod'
import { auth } from '@server/auth'
import {
  dismissPersonaPromptForUser,
  readPersonaProfileForUser,
  savePersonaForUser,
} from '@server/persona'
import { PERSONA_IDS } from '@shared/persona'

async function getSessionUser() {
  const request = getRequest()
  const session = await auth.api.getSession({ headers: request.headers })
  return session?.user ?? null
}

export const getPersonaProfile = createServerFn({ method: 'GET' }).handler(
  async () => {
    const sessionUser = await getSessionUser()
    if (!sessionUser) return null
    return readPersonaProfileForUser(sessionUser.id)
  },
)

export const updatePersona = createServerFn({ method: 'POST' })
  .inputValidator(
    z.object({
      persona: z.enum(PERSONA_IDS),
      source: z.enum(['chat_prompt', 'settings']),
    }),
  )
  .handler(async ({ data }) => {
    const sessionUser = await getSessionUser()
    if (!sessionUser) throw new Error('Unauthorized')

    await savePersonaForUser({ userId: sessionUser.id, ...data })
    return { success: true, persona: data.persona }
  })

export const dismissPersonaPrompt = createServerFn({
  method: 'POST',
}).handler(async () => {
  const sessionUser = await getSessionUser()
  if (!sessionUser) throw new Error('Unauthorized')

  await dismissPersonaPromptForUser(sessionUser.id)
  return { success: true }
})
